import * as React from 'react';
import { useTranslation } from 'react-i18next';
import './AccountCreated.scss';

const CreateUser: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='account-created'>
      <h2 className='text-center fcolor--primary-brand'>
        {t('accountCreated_heading')}
      </h2>
      <div className='content mx-auto'>
        <div className='sub-heading'>{t('accountCreated_subHeading')}</div>
        <p className='mt-4'>{t('accountCreated_details')}</p>
        <p>{t('accountCreated_help')}</p>
      </div>
    </div>
  );
};

export default CreateUser;
